import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { Link, useNavigate } from 'react-router-dom';
import GuideBook from '../components/GuideBook';

export default function MyWebinars() {
  const [webinars, setWebinars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showGuide, setShowGuide] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const guideSeen = localStorage.getItem('guidebook_seen');
    if (!guideSeen) {
      setShowGuide(true);
      localStorage.setItem('guidebook_seen', Date.now().toString());
    }

    const fetchWebinars = async () => {
      try {
        const res = await api.get('/api/member/webinars');
        setWebinars(res.data);
      } catch (err) {
        if (err.response?.status === 401) {
          localStorage.removeItem('member_user');
          navigate('/login');
          return;
        }
        setError('Gagal memuat data webinar.');
      } finally {
        setLoading(false);
      }
    };
    fetchWebinars();
  }, [navigate]);

  const user = JSON.parse(localStorage.getItem('member_user') || 'null');

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-warning" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Memuat webinar Anda...</p>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="mb-4 d-flex justify-content-between align-items-center">
        <div>
          <h2 className="fw-bold mb-0">Kelas Saya</h2>
          {user && <p className="text-muted mb-0">Selamat datang, {user.name}!</p>}
        </div>
        <button
          className="btn btn-outline-dark btn-sm d-flex align-items-center gap-1"
          onClick={() => setShowGuide(true)}
          title="Panduan Fitur"
        >
          <i className="bi bi-question-circle"></i>
          <span className="d-none d-md-inline">Panduan</span>
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {webinars.length === 0 ? (
        <div className="text-center py-5">
          <div className="mb-3" style={{ fontSize: '4rem' }}>📚</div>
          <h5>Belum ada kelas</h5>
          <p className="text-muted">
            Anda belum memiliki akses ke kelas manapun. Silakan daftar kelas terlebih dahulu.
          </p>
          <Link to="/kelas" className="btn btn-dark">Daftar Kelas</Link>
        </div>
      ) : (
        <div className="row g-4">
          {webinars.map(webinar => (
            <div key={webinar.id} className="col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm">
                {webinar.image && (
                  <img
                    src={`data:image/png;base64,${webinar.image}`}
                    className="card-img-top"
                    alt={webinar.title}
                    style={{ height: '160px', objectFit: 'cover' }}
                  />
                )}
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{webinar.title}</h5>
                  <p className="card-text text-muted small flex-grow-1">
                    {webinar.description?.substring(0, 100)}
                    {webinar.description?.length > 100 ? '...' : ''}
                  </p>

                  {webinar.total_episodes > 0 && (
                    <div className="mb-2">
                      <div className="d-flex justify-content-between small text-muted mb-1">
                        <span>Progress</span>
                        <span>{webinar.progress}%</span>
                      </div>
                      <div className="progress" style={{ height: '8px' }}>
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: `${webinar.progress}%` }}
                        />
                      </div>
                      <small className="text-muted">
                        {webinar.completed_episodes}/{webinar.total_episodes} episode selesai
                      </small>
                    </div>
                  )}

                  {webinar.has_certificate && (
                    <span className="badge bg-success mb-2">
                      <i className="bi bi-award me-1"></i>Sertifikat Tersedia
                    </span>
                  )}

                  <Link
                    to={`/learning/${webinar.id}/episodes`}
                    className="btn btn-dark w-100 mt-auto"
                  >
                    {webinar.progress > 0 ? 'Lanjutkan Belajar' : 'Mulai Belajar'}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <GuideBook show={showGuide} onClose={() => setShowGuide(false)} />
    </div>
  );
}
